export default __webpack_public_path__ + "static/Tripadvisor_CaseStudy_Title-Video-720-f339cf7004d927ed8e52fe38911c5486.mp4";